import React from 'react';
import Text from '../Form/Text';

const styles = {
  padding: '20px',
  fontSize: '1.4em'
}
class Title extends React.Component {
  render() {
    const { label } = this.props;
    return (
      <div style={styles}> {label && <Text className="Text-question"> {label} </Text>} </div>
    );
  }
};

Title.defaultProps = {
  label: 'Nuestra mejor cotización para vos', 
};

export default Title;
